<template>
  <div>
    <b-row class="d-flex">
      <b-col class="d-flex justify-content-end button-group">
        <b-btn variant="outline-success" @click="activateProducts('activate', 'activated', 'activating')" size="sm">
          {{$t('buttons.products.activate_products')}}
        </b-btn>
        <b-btn variant="outline-primary" @click="activateProducts('deactivate', 'deactivated', 'deactivating')"
               size="sm">
          {{$t('buttons.products.deactivate_products')}}
        </b-btn>
        <img v-if="currentRoutePermissions.add_product"
             src="@/assets/images/common-icons/icon_create.svg" @click="create"
             :title="$t('buttons.products.create_product')">
        <img v-if="currentRoutePermissions.delete_product"
             src="@/assets/images/common-icons/icon_delete.svg" @click="deleteProducts"
             :title="$t('buttons.products.delete_product')">
        <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
             :title="$t('buttons.common.clear_filters')">
        <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
             :title="$t('buttons.common.search')">
      </b-col>
    </b-row>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col cols="3">
            <label>{{$t('labels.common.group')}}</label>
            <multiselect v-model="searchData.groups" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="groups" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""
            ></multiselect>
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.pellets.unit_weight')}}</label>
            <multiselect v-model="searchData.unit_weights"
                         :max-height="200"
                         placeholder="" label="" track-by=""
                         :options="unit_weights" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.common.quality')}}</label>
            <multiselect v-model="searchData.qualities" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="qualities_list" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.pellets.diameter')}}</label>
            <multiselect v-model="searchData.diameters" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="pellet_diameters" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <label>{{$t('labels.common.wood')}}</label>
            <multiselect v-model="searchData.trees" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="wood" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.common.quantity')}}</label>
            <multiselect v-model="searchData.pieces"
                         placeholder=""
                         :options="pieces_list" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.pellets.bag_logo')}}</label>
            <multiselect v-model="searchData.bag_logos" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="bag_logos" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.common.certificate')}}</label>
            <multiselect v-model="searchData.wood_certificates" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="wood_certificates" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <label>{{$t('labels.common.smart_search')}}
              <smart-search-badge></smart-search-badge>
            </label>
            <input class="form-control" v-model="searchData.smart_search" @keyup.enter="search()">
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.pellets.pallet_size')}}</label>
            <multiselect v-model="searchData.pallet_sizes" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="pallet_sizes" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.common.status')}}</label>
            <multiselect v-model="searchData.is_active" :max-height="200"
                         placeholder="" label="name" track-by="value"
                         :options="statuses"
                         :close-on-select="true"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col cols="3">
          </b-col>
        </b-row>
      </div>
    </div>
    <div>
      <b-row>
        <b-col class="d-flex justify-content-start align-items-center">
          <span v-for="item in selectedData" :key="item.text" class="selected-info__item">
                        {{$t(`labels.common.${item.label}`)}}: {{item.value.toLocaleString('ru-RU')}}
                    </span>
        </b-col>
        <b-col class="d-flex justify-content-end align-items-center">
          <save-columns-btn :grid="gridOptions" :grid-name="gridName"
                            class="margin-left-5"></save-columns-btn>
        </b-col>
      </b-row>
    </div>
    <div>
      <b-row>
        <b-col>
          <ag-grid-vue class="ag-theme-balham" :gridOptions="gridOptions"
                       :selectionChanged="selectionChangedOperations"
                       :style="gridHeight" :rowData="products" :columnDefs="columns"
                       @rowDoubleClicked="redirectToProduct"
                       :postProcessPopup="postProcessPopup">
          </ag-grid-vue>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import { mapGetters, mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import {
    cleanFilters,
    saveFilters,
    setFilters,
    checkSavedFilterData,
    getArrayByProperty,
    sumTotalData,
    setNotifyData
  } from '@/helpers/commonHelpers';

  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import SmartSearchBadge from '@/components/common/SmartSearchBadge';
  import { gridMixins } from '@/mixins';

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      'ag-grid-vue': AgGridVue,
      SaveColumnsBtn,
      SmartSearchBadge
    },
    data() {
      return {
        selectedData: [
          {
            label: 'selected',
            value: 0
          }
        ],
        searchData: {
          groups: [],
          trees: [],
          qualities: [],
          unit_weights: [],
          smart_search: '',
          pieces: [],
          pallet_sizes: [],
          wood_certificates: [],
          bag_logos: [],
          diameters: [],
          is_active: null
        },
        storageKey: 'products',
        statuses: [
          {name: 'Active', value: true},
          {name: 'Inactive', value: false}
        ]
      }
    },
    computed: {
      ...mapState('generic', ['currentRoutePermissions']),
      ...mapState('woodware', ['groups', 'wood', 'qualities_list', 'wood_certificates',
                 'pieces_list', 'pallet_sizes', 'bag_logos', 'pellet_diameters', 'unit_weights']),
      ...mapState('products', ['gridName', 'products', ]),
      ...mapGetters('products', ['gridOptions', 'columns']),
      gridHeight() {
        return {height: 'calc(100vh - 360px)'};
      }
    },
    methods: {
      create() {
        this.$router.push({path: `/product/new`});
      },
      async deleteProducts() {
        const ids = getArrayByProperty(this.gridOptions.api.getSelectedRows(), 'id');
        if (ids.length) {
          try {
            const notifyData = await this.$http.delete(`woodware/products/`, {body: {ids}});
            this.$notify(setNotifyData('', notifyData.body, 'success'));
            this.search();
          } catch (e) {
            this.$notify(setNotifyData('Error', e, 'error'));
          }
        } else {
          this.$notify(setNotifyData('Select products for removing', '', 'warn'));
        }
      },
      cleanFilters() {
        cleanFilters(this.searchData, this.storageKey);
      },
      async search() {
        const searchData = this.prepareSearchData();
        await this.$store.dispatch('products/loadProducts', searchData).then(() => {
          this.selectedData = sumTotalData([], this.selectedData);
        });
        saveFilters(this.storageKey, this.searchData);
      },
      prepareSearchData() {
        return {
          groups: getArrayByProperty(this.searchData.groups, 'id').toString(),
          trees: getArrayByProperty(this.searchData.trees, 'id').toString(),
          qualities: getArrayByProperty(this.searchData.qualities, 'id').toString(),
          unit_weights: getArrayByProperty(this.searchData.unit_weights, 'id').toString(),
          pieces: this.searchData.pieces && this.searchData.pieces.toString(),
          pallet_sizes: getArrayByProperty(this.searchData.pallet_sizes, 'id').toString(),
          bag_logos: getArrayByProperty(this.searchData.bag_logos, 'id').toString(),
          diameters: getArrayByProperty(this.searchData.diameters, 'id').toString(),
          smart_search: this.searchData.smart_search,
          wood_certificates: getArrayByProperty(this.searchData.wood_certificates, 'id').toString(),
          is_active: this.searchData.is_active && this.searchData.is_active.value.toString()
        }
      },
      selectionChangedOperations() {
        const selectedProducts = this.gridOptions.api.getSelectedRows();
        this.selectedData = sumTotalData(selectedProducts, this.selectedData);
      },
      redirectToProduct(params) {
        if (params.data && params.data.id) {
          this.$router.push({path: `/product/${params.data.id}`});
        }
      },
      activateProducts(type, notifySuccess, notifyEmpty) {
        const ids = getArrayByProperty(this.gridOptions.api.getSelectedRows(), 'id');
        if (ids.length) {
          const products = {
            id: ids
          };
          const count = ids.length;
          this.$http.post(`woodware/products/${type}/`, products)
            .then(() => {
              this.$notify(setNotifyData('', this.$i18n.t(`alerts.${notifySuccess}_products`, {count}), 'success'));
              this.search();
            }).catch(error => {
            this.$notify(setNotifyData('Error', error, 'error'));
          });
        } else {
          this.$notify(setNotifyData(`Select products for ${notifyEmpty}`, '', 'warn'));
        }
      }
    },
    beforeMount() {
      this.$store.cache.dispatch('woodware/getWood');
      this.$store.cache.dispatch('woodware/getQualitiesList');
      this.$store.cache.dispatch('woodware/getGroupsWithHierarchy');
      this.$store.cache.dispatch('woodware/getWoodCertificates');
      this.$store.cache.dispatch('woodware/getPiecesList');
      this.$store.cache.dispatch('woodware/fetchBagLogos');
      this.$store.cache.dispatch('woodware/fetchPelletDiameters');
      this.$store.cache.dispatch('woodware/fetchUnitWidths');
      this.$store.cache.dispatch('woodware/fetchPalletSizes');
      if (checkSavedFilterData(this.storageKey)) {
        this.searchData = setFilters(this.storageKey);
      }
    },
    beforeDestroy() {
      const emptyData = {
        data: [],
        used_columns: [],
        grid_name: ''
      };
      this.$store.commit('products/setData', emptyData);
    }
  }
</script>

<style scoped>
  .selected-info__item {
    font-weight: bold;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/modules/general/products/ProductsList.vue